import React, { Component } from 'react'
import RoleControlled from '../../_common/RoleControlled'
import { deleteMsg } from '../../../const'

class ManualItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultTitle: this.props.manual.title,
      defaultShow: this.props.manual.is_show,
      defaultURL: this.props.manual.file_url,
      title: this.props.manual.title,
      is_show: this.props.manual.is_show,
      file_url: this.props.manual.file_url,
      pdf: ''
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { manual } = this.props
    const { edit, title, is_show, file_url } = this.state
    if (
      manual.title !== nextProps.manual.title ||
      manual.is_show !== nextProps.manual.is_show ||
      manual.file_url !== nextProps.manual.file_url ||
      edit !== nextState.edit ||
      title !== nextState.title ||
      is_show !== nextState.is_show ||
      file_url !== nextState.file_url
    ) {
      return true
    } else {
      return false
    }
  }

  _handleEditClick () {
    this.setState({ edit: true })
  }
  _handleDeleteClick () {
    console.log('delete manual id: ', this.props.manual.manual_id)
    const res = window.confirm(deleteMsg)
    if (res) {
      this.props.deleteData(this.props.manual.manual_id)
    }
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      title: this.state.title,
      is_show: this.state.is_show,
      file_url: this.state.file_url
    })
  }
  _handleSaveClick () {
    const { title, is_show, pdf } = this.state
    const data = {
      manual_id: this.props.manual.manual_id,
      title,
      is_show
    }
    const callback = () => {
      this.setState({ edit: false })
    }
    if (!this.state.pdf) {
      this.props.saveData(callback, data)
    } else {
      this.props.saveData(callback, data, pdf)
    }
  }

  _handleShowSwitch (e) {
    this.setState({ is_show: e.target.checked })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _handleAddPDF (e) {
    const pdf = e.target.files[0]
    console.log(pdf)
    if (pdf) {
      if (pdf.type === 'application/pdf' && pdf.name.indexOf('pdf') > 0) {
        this.setState({ pdf, file_url: URL.createObjectURL(pdf) })
        console.log('sending pdf file')
      } else {
        console.log('wrong file type')
        // this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _renderManualTitle () {
    if (this.state.edit) {
      return <input type="text" value={this.state.title} onChange={this._handleUpdateContent.bind(this, 'title')}/>
    }
    return (
      <div className="manual_value value">{this.state.title}</div>
    )
  }
  _renderManualShow () {
    if (this.state.edit) {
      return [
        <input type="checkbox" id={`${this.props.manual.manual_id}_showSwitch`} className="switch-input" key="checkbox" onChange={this._handleShowSwitch.bind(this)} checked={this.state.is_show}/>,
        <label htmlFor={`${this.props.manual.manual_id}_showSwitch`} className="switch-label" key="label">
          <span className="toggle--on">表示</span>
          <span className="toggle--off">非表示</span>
        </label>
      ]
    } else {
      if (this.state.is_show) {
        return <span className="tag show">表示</span>
      }
      return <span className="tag hide">非表示</span>
    }
  }
  _renderManualLink () {
    if (this.state.edit) {
      return (
        <label htmlFor={`add_csv_${this.props.manual.manual_id}`} className="btn primary flex align-center">
          <svg viewBox="0 0 24 24" className="icon_upload">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          <span>PDFファイル</span>
          <input
            type="file"
            id={`add_csv_${this.props.manual.manual_id}`}
            onChange={this._handleAddPDF.bind(this)}
          />
        </label>
      )
    } else {
      if (!this.state.file_url) {
        return null
      }
      return (
        <a className="btn primary manual_value value file_link flex align-center justify-center" href={`${this.state.file_url}`} target="_blank">
          <svg viewBox="0 0 24 24" className="icon_send">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
          <span>PDFファイル</span>
        </a>
      )
    }
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className={ !this.state.is_show ? 'manual hide' : 'manual' }>
        <div className="manual_inner admin_inner flex column">
          <div className="contents flex top_label justify-between">
            <div className="left flex">
              <div className="manual_label label">PDFタイトル</div>
              { this._renderManualTitle()}
            </div>
            <div className="right">
              { this._renderManualShow() }
            </div>
          </div>
          <div className="contents flex bottom_label">
            { this._renderManualLink()}
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>
      </article>
    )
  }
}

export default ManualItem



// WEBPACK FOOTER //
// ./src/components/Properties/Manuals/ManualItem.js